import { Avatar, Flex, Text } from '@chakra-ui/react';
import type { ResumedUserType } from '@customTypes/user';
import { formatDate } from '@utils/date';

type Props = {
  user: ResumedUserType,
  createdDate: string,
};

const CreatedBy = ({ user, createdDate }: Props) => {
  return (
    <Flex gap={1} align="center" mt={2}>
      <Avatar.Root variant="outline" borderColor="border.muted" width={6} height={6} size="xs">
        <Avatar.Fallback name={user.name || ''} />
        {user.thumbnail_url && (
          <Avatar.Image src={user.thumbnail_url} />
        )}
      </Avatar.Root>
      <Text color="fg.muted" textStyle="xs">
        {user.name}
        {' '}
        em
        {' '}
        {formatDate(createdDate)}
      </Text>
    </Flex>
  );
};

export default CreatedBy;
